import styles from "./FeaturePage.module.css";
import FeatureCard from "../../components/FeaturesCard/Index";
import featuresData from "../../data/feature.json";
import {
  Grid,
  Pagination,
  TextField,
  IconButton,
  Menu,
  MenuItem
} from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { useEffect, useState } from "react";

const index = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const itemsPerPage = 15;
  const [role, setRole] = useState("admin");
  const [anchorEl, setAnchorEl] = useState(null);

  const filteredFeatures = featuresData.filter((feature) => {
    const title = feature.title?.toLowerCase() || "";
    const query = searchQuery.toLowerCase();

    const matchesSearch = title.includes(query);
    const matchesRole = role ? feature.filter?.includes(role.toLowerCase()) : true;

    return matchesSearch && matchesRole;
  });

  const currentFeatures = filteredFeatures.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredFeatures.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, role]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFilterSelect = (selectedRole) => {
    setRole(selectedRole.toLowerCase());
    handleMenuClose();
  };

  return (
    <div>
      <div className={`${styles.containerbcg}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.contmargin}`}>
            <div className={`${styles.requestheader}`}>
              <Grid container alignItems={"center"}>
                <Grid item lg={9} md={9} sm={9} xs={9}>
                  <h3>Shelf21 Features</h3>
                  <p>
                    See the list of features you have access to as a premium
                    user of shelf21. Empowering Schools, Engaging Students, and
                    Connecting Parents, all in one platform.
                  </p>
                </Grid>
                {/* <Grid item lg={3} md={3} sm={3} xs={4}>
                  <div
                    className={`${styles.explore} flex align-item-center gap-8 justify-end`}
                  >
                    <Link to="https://st-app.shelf21.com/auth/signup" target="_blank">Sign up to explore all</Link>
                    <div>
                      <NorthEastIcon className="light-blue margin-top-10" />
                    </div>
                  </div>
                </Grid> */}
              </Grid>
            </div>
            <Grid item lg={12} md={12} sm={12} xs={12} className={styles.search}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search features..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className={styles.searchInput}
                />
                <IconButton onClick={handleMenuOpen}>
                  <FilterList />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={() => handleFilterSelect("")}>All</MenuItem>
                  <MenuItem onClick={() => handleFilterSelect("Admin")}>Admin</MenuItem>
                  <MenuItem onClick={() => handleFilterSelect("Teacher")}>Teacher</MenuItem>
                  <MenuItem onClick={() => handleFilterSelect("Parent")}>Parent</MenuItem>
                  <MenuItem onClick={() => handleFilterSelect("Student")}>Student</MenuItem>
                </Menu>
              </div>

            </Grid>
            <div>
              <Grid container spacing={2}>
                {currentFeatures.map((feature, index) => (
                  <Grid item lg={4} md={4} sm={6} xs={12} key={index}
                    className={styles.featureGridItem}
                    rowSpacing={4}
                  >
                    <FeatureCard
                      title={feature.title}
                      description={feature.description}
                      videoUrl={feature.link}
                      textColor={feature.textColor}
                      backgroundColor={feature.backgroundColor}
                      className={styles.featureCardWrapper}
                    />
                  </Grid>
                ))}
              </Grid>
              <div className={styles.paginationContainer}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
